module.exports = __webpack_public_path__ + "static/media/website.5c5aec0d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website.svg
// module id = 335
// module chunks = 0